import Vue from 'vue'
import resize from "vue-element-resize-detector";

Vue.use(resize)
